export const NFT_TOKEN = "0xC9acFE3D68358f420deF60c034954AE74C13af57";
export const STAKE_CONTRACT = '0x98748a6b04dF297972356eEfbE11805cA2874B6e';
export const REWARD = [NFT_TOKEN];
export const CHAIN_ID = 97;